// DO NOT EDIT THIS FILE.
// THIS IS A GENERATED FILE AND ANY EDIT WILL BE REPLACED
// Home: github.com/00-team/argon
import * as ud from './user_defined';
export const API_VERSION = '0.0.1';

// @ts-ignore
type _Map<V> = { [key: string]: V }

export type FarmError = "unknown"|"bad_request"|"forbidden"|"bad_auth"|"not_found"|"server_error"|"database_error"|"rate_limited"|"banned"|"change_while_reordering"|"index_out_of_bounds"|"invalid_image"|"encode_webp_error"|"end_point_under_maintenance"|"bad_wheat_ard_json_data"|"reqwest_error"|"bad_username"|"wrong_password"|"bad_wheat_priority"|"plugin_build"|"unknown_kind"|"zstd_compress_failed"|"mapack";
export const FARM_ERROR = ["unknown","bad_request","forbidden","bad_auth","not_found","server_error","database_error","rate_limited","banned","change_while_reordering","index_out_of_bounds","invalid_image","encode_webp_error","end_point_under_maintenance","bad_wheat_ard_json_data","reqwest_error","bad_username","wrong_password","bad_wheat_priority","plugin_build","unknown_kind","zstd_compress_failed","mapack",] as const;
export function is_farm_error(value: string): value is FarmError {
    return FARM_ERROR.includes(value as FarmError)
}
;
export type AppErr = { code:FarmError,debug?:(((string) | null)),status:(number), };
export type TaskPluginKernelInfo = { progress:(number),total:(number), };
export type TaskKernelUpdateInfo = { progress:(number),total:(number), };
export type FarmTaskData = (TaskPluginKernelInfo&({ kind:("plugin_kernel"), }))|(TaskKernelUpdateInfo&({ kind:("kernel_update"), }));
export type TaskId = string;
export type ConcurrentTask = { abort:(boolean),created_at:(number),data:FarmTaskData,done_at:(number),error?:((FarmError | null)),id:TaskId, };
export type ConcurrentTask_FarmTaskData = { abort:(boolean),created_at:(number),data:FarmTaskData,done_at:(number),error?:((FarmError | null)),id:TaskId, };
export type Count = { alive:(number),max_page:(number),size:(number),total:(number), };
export type EntityFlags = { is_alive:(boolean), };
export type EntityFlagsInfo = { is_alive:(boolean), };
export type FarmerFlags = { banned:(boolean), };
export type Gene = ((string) | null);
export type ShahString = string;
export type Farmer = { created_at:(number),entity_flags:EntityFlags,farmed_at:(number),flags:FarmerFlags,gene:Gene,growth:(number),name:ShahString,token:ShahString,wheat_ards:(number),wheat_kernels:(number),wheats:(number), };
export type FarmerUpdateBody = { name:(string),token_reset:(boolean), };
export type FarmersUpdateBody = { banned:(boolean),name:(string),token_reset:(boolean), };
export type ShahEnum_u8_WheatKernelBasket = "good"|"junk";
export const SHAH_ENUM_U8__WHEAT_KERNEL_BASKET = ["good","junk",] as const;
export function is_shah_enum_u8__wheat_kernel_basket(value: string): value is ShahEnum_u8_WheatKernelBasket {
    return SHAH_ENUM_U8__WHEAT_KERNEL_BASKET.includes(value as ShahEnum_u8_WheatKernelBasket)
}
;
export type Location = { latitude:(number),longitude:(number), };
export type ShahEnum_u8_WheatCategory = "unknown"|"restaurant"|"cafe"|"bar";
export const SHAH_ENUM_U8__WHEAT_CATEGORY = ["unknown","restaurant","cafe","bar",] as const;
export function is_shah_enum_u8__wheat_category(value: string): value is ShahEnum_u8_WheatCategory {
    return SHAH_ENUM_U8__WHEAT_CATEGORY.includes(value as ShahEnum_u8_WheatCategory)
}
;
export type WheatKernel = { basket:ShahEnum_u8_WheatKernelBasket,buckle:Gene,created_at:(number),entity_flags:EntityFlags,gene:Gene,growth:(number),id:(string),location:Location,name:ShahString,next:Gene,past:Gene,pending_at:(number),title:ShahString,updated_at:(number),wheat:Gene,wheat_category:ShahEnum_u8_WheatCategory,wheat_priority:(number), };
export type KernelStateResult = { count:(number),list:((WheatKernel[])), };
export type LoginBody = { password:(string),username:(string), };
export type Zstr = string;
export type ShahEnum_u8_PluginKind = "unknown"|"kernel";
export const SHAH_ENUM_U8__PLUGIN_KIND = ["unknown","kernel",] as const;
export function is_shah_enum_u8__plugin_kind(value: string): value is ShahEnum_u8_PluginKind {
    return SHAH_ENUM_U8__PLUGIN_KIND.includes(value as ShahEnum_u8_PluginKind)
}
;
export type Plugin = { buckle:Gene,code:Zstr,code_full:Gene,entity_flags:EntityFlags,gene:Gene,growth:(number),kind:ShahEnum_u8_PluginKind,next:Gene,past:Gene,title:ShahString, };
export type PluginCodeFile = { body:(string),name:(string), };
export type PluginKind = "unknown"|"kernel";
export const PLUGIN_KIND = ["unknown","kernel",] as const;
export function is_plugin_kind(value: string): value is PluginKind {
    return PLUGIN_KIND.includes(value as PluginKind)
}
;
export type ShahBuckle = { belt_count:(number),entity_flags:EntityFlags,gene:Gene,growth:(number),head:Gene,tail:Gene, };
export type PluginRoot = { kernel:ShahBuckle, };
export type PluginUpdateBody = { code:(string),title:(string), };
export type Session = { ip:(string),timestamp:(number),token:ShahString, };
export type TaskKernelUpdateBody = { tiles:(boolean), };
export type UserInfo = { created_at:(number),entity_flags:EntityFlagsInfo,gene:Gene,name:(string),session_index:(number),sessions:((Session[])),username:(string), };
export type UserUpdateBody = { name:(string), };
export type Wheat = { buckle:Gene,entity_flags:EntityFlags,flags:(number),gene:Gene,growth:(number),kernels:(number),next:Gene,past:Gene,pending:(number),priority:(number),tx:(number),ty:(number),updated:(number), };
export type WheatCategory = "unknown"|"restaurant"|"cafe"|"bar";
export const WHEAT_CATEGORY = ["unknown","restaurant","cafe","bar",] as const;
export function is_wheat_category(value: string): value is WheatCategory {
    return WHEAT_CATEGORY.includes(value as WheatCategory)
}
;
export type WheatKernelAddInfo = { created_at:(number),id:([ (number),(number), ]),location:Location,name:(string),title:(string),wheat_category:WheatCategory, };
export type WheatKernelAddBody = { kernels:((WheatKernelAddInfo[])),wheat:Gene, };
export type WheatKernelBasket = "good"|"junk";
export const WHEAT_KERNEL_BASKET = ["good","junk",] as const;
export function is_wheat_kernel_basket(value: string): value is WheatKernelBasket {
    return WHEAT_KERNEL_BASKET.includes(value as WheatKernelBasket)
}
;
export type WheatKernelRoot = { good:ShahBuckle,junk:ShahBuckle, };
export type WheatMarkKind = "void"|"road"|"village"|"town"|"city";
export const WHEAT_MARK_KIND = ["void","road","village","town","city",] as const;
export function is_wheat_mark_kind(value: string): value is WheatMarkKind {
    return WHEAT_MARK_KIND.includes(value as WheatMarkKind)
}
;
export type WheatMarkGroup = { kind:WheatMarkKind,tiles:((([ (number),(number), ])[])), };
export type WheatMarkBody = { groups:((WheatMarkGroup[])),remark:(boolean), };
export type WheatRoot = { entity_flags:EntityFlags,gene:Gene,growth:(number),head:Gene,kernels:(number),tail:Gene,updated:(number),wheats:(number), };
/**
List

*/
export async function api_farmers_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((Farmer[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/farmers/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((Farmer[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((Farmer[]))>

}
/**
Add

*/
export async function api_farmers_post (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Farmer>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/farmers/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Farmer> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Farmer>

}
/**
Count

*/
export async function api_farmers_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/farmers/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Get

*/
export async function api_farmers_get (params: {gene:Gene,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Farmer>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/farmers/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Farmer> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Farmer>

}
/**
Delete

*/
export async function api_farmers_del (params: {gene:Gene,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Farmer>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/farmers/${gene}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Farmer> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Farmer>

}
/**
Update

*/
export async function api_farmers_patch (params: {gene:Gene,}, body: FarmersUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Farmer>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/farmers/${gene}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Farmer> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Farmer>

}
/**
Get

*/
export async function api_farming_farmer_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Farmer>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/farming/farmer/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Farmer> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Farmer>

}
/**
Update

*/
export async function api_farming_farmer_patch (body: FarmerUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Farmer>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/farming/farmer/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Farmer> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Farmer>

}
/**
Kernel Add

*/
export async function api_farming_wheat_kernel_post (body: WheatKernelAddBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Wheat>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/farming/wheat/kernel/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Wheat> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Wheat>

}
/**
Pluck - Mill - Grain - Sieve - Filter

*/
export async function api_farming_wheat_pluck_post (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Wheat>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/farming/wheat/pluck/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Wheat> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Wheat>

}
/**
Plugin Tail List

*/
export async function api_plugin_belt_list_list (params: {tail:Gene,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((Plugin[]))>> {
    let { tail } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/plugin/belt-list/${tail}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((Plugin[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((Plugin[]))>

}
/**
Root

*/
export async function api_plugin_root_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<PluginRoot>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/plugin/root/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<PluginRoot> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<PluginRoot>

}
/**
Plugin Get

*/
export async function api_plugin_get (params: {gene:Gene,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Plugin>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/plugin/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Plugin> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Plugin>

}
/**
Plugin Del

*/
export async function api_plugin_del (params: {gene:Gene,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Plugin>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/plugin/${gene}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Plugin> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Plugin>

}
/**
Plugin Update

*/
export async function api_plugin_patch (params: {gene:Gene,}, body: PluginUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Plugin>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/plugin/${gene}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Plugin> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Plugin>

}
/**
Plugin Add

*/
export async function api_plugin_post (params: {kind:PluginKind,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Plugin>> {
    let { kind } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/plugin/${kind}/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Plugin> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Plugin>

}
/**
List

*/
export async function api_tasks_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((ConcurrentTask_FarmTaskData[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/tasks/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((ConcurrentTask_FarmTaskData[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((ConcurrentTask_FarmTaskData[]))>

}
/**
Kernel Update

*/
export async function api_tasks_kernel_update_post (body: TaskKernelUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ConcurrentTask>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/tasks/kernel/update/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ConcurrentTask> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ConcurrentTask>

}
/**
Plugin Kernel

*/
export async function api_tasks_plugin_kernel_post (body: PluginCodeFile, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ConcurrentTask>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/tasks/plugin/kernel/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ConcurrentTask> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ConcurrentTask>

}
/**
Plugin Kernel Check

*/
export async function api_tasks_plugin_kernel_check_post (body: PluginCodeFile, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<string>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/tasks/plugin/kernel/check/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.text(),
        ok(): this is ud.Ok<string> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<string>

}
/**
Abort

*/
export async function api_tasks_del (params: {id:TaskId,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ConcurrentTask_FarmTaskData>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/tasks/${id}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ConcurrentTask_FarmTaskData> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ConcurrentTask_FarmTaskData>

}
/**
Get

*/
export async function api_user_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserInfo>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/user/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserInfo>

}
/**
Update

*/
export async function api_user_patch (body: UserUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/user/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Login

*/
export async function api_user_login_post (body: LoginBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserInfo>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/user/login/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserInfo>

}
/**
Logout

*/
export async function api_user_logout_post (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/user/logout/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Delete Session

*/
export async function api_user_sessions_del (params: {sid:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { sid } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/user/sessions/${sid}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
List

*/
export async function api_wheat_kernel_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((WheatKernel[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/wheat-kernel/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((WheatKernel[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((WheatKernel[]))>

}
/**
Count

*/
export async function api_wheat_kernel_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/wheat-kernel/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Plugin Export

*/
export async function api_wheat_kernel_plugin_export_list (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<(((string)[]))>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/wheat-kernel/plugin-export/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<(((string)[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<(((string)[]))>

}
/**
Plugin state move

*/
export async function api_wheat_kernel_plugin_state_move_post (params: {kind:WheatKernelBasket,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { kind } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/wheat-kernel/plugin-state-move/${kind}/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Plugin state

*/
export async function api_wheat_kernel_plugin_state_get (params: {page:(number),kind:WheatKernelBasket,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<KernelStateResult>> {
    let { page,kind } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/wheat-kernel/plugin-state/`,
        method: 'GET',
        params: { page,kind },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<KernelStateResult> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<KernelStateResult>

}
/**
Root

*/
export async function api_wheat_kernel_root_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<WheatKernelRoot>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/wheat-kernel/root/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<WheatKernelRoot> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<WheatKernelRoot>

}
/**
Wheat Get

*/
export async function api_wheat_kernel_get (params: {gene:Gene,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<WheatKernel>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/wheat-kernel/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<WheatKernel> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<WheatKernel>

}
/**
List

*/
export async function api_wheat_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((Wheat[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/wheat/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((Wheat[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((Wheat[]))>

}
/**
Count

*/
export async function api_wheat_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/wheat/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
display

*/
export async function api_wheat_display_list (params: {z:(number),x:(number),y:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ArrayBuffer>> {
    let { z,x,y } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/wheat/display/${z}-${x}-${y}`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.arrayBuffer(),
        ok(): this is ud.Ok<ArrayBuffer> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ArrayBuffer>

}
/**
Wheat Mark

*/
export async function api_wheat_mark_patch (body: WheatMarkBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/wheat/mark/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Root

*/
export async function api_wheat_root_list (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((WheatRoot[]))>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/wheat/root/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((WheatRoot[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((WheatRoot[]))>

}
/**
Wheat Get

*/
export async function api_wheat_get (params: {gene:Gene,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Wheat>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/wheat/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Wheat> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Wheat>

}
/**
Xenos Get

*/
export async function api_xenos_get (params: {gene:Gene,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<string>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/xenos/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.text(),
        ok(): this is ud.Ok<string> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<string>

}
